import { isDevMode, NgModule } from '@angular/core';
import { provideTransloco, TranslocoModule } from '@jsverse/transloco';
import { provideTranslocoLocale, TranslocoLocaleModule } from '@jsverse/transloco-locale';

import { TranslocoUtils } from './utils/transloco.utils';

@NgModule({
  exports: [TranslocoModule, TranslocoLocaleModule],
  imports: [TranslocoModule, TranslocoLocaleModule],
  providers: [
    provideTransloco({
      config: {
        availableLangs: [...TranslocoUtils.LANGS],
        defaultLang: TranslocoUtils.DEFAULT_LANG,
        fallbackLang: TranslocoUtils.DEFAULT_LANG,
        reRenderOnLangChange: true,
        prodMode: !isDevMode(),
      },
    }),
    provideTranslocoLocale({
      langToLocaleMapping: TranslocoUtils.LANG_TO_LOCALE_MAPPING,
    }),
  ],
})
export class TranslocoRootModule {}
